// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { IDynamicItemValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { RecommendedItemsResponseType } from 'models-recommendation';

import { createInstance } from '../utils/dynamic-items-utils';

import {
  hasError,
  isLoading,
  LoadingStateWrapper,
} from './loading-state-wrapper-helpers';

export function getRecommendationsDataProviderItem(providers: {
  panelName: IDynamicItemValue;
  apiRequestPayloadPropertiesProvider: IDynamicItemValue;
}) {
  const item = createInstance({
    id: 'recommendations-data',
    contentTypeId: 'dynamic-collections-renderer',
    data: {
      loadingStateWrapper: {
        provider: 'HttpBodyProvider',
        property: {
          values: [
            providers.panelName,
            providers.apiRequestPayloadPropertiesProvider,
          ],
          transform: function ([panelName, apiRequestPayloadProperties]: [
            string,
            { [key: string]: unknown },
          ]) {
            const body = {
              panelType: panelName,
              properties: {
                ...apiRequestPayloadProperties,
              },
            };

            const url = '/api/v2/recommendation/suggest';
            const method = 'POST';
            const fetchString =
              window.neoclesDynamicFramework.recommendationsPanels.methods.createHttpRequestFetchString(
                url,
                method,
                body,
              );

            return fetchString;
          }.toString(),
        },
        wrapWithLoadingState: true,
      },
      isLoading: isLoading(),
      hasError: hasError(),
      result: {
        provider: 'self',
        property: 'loadingStateWrapper',
        filter: function (
          loadingStateWrapper: LoadingStateWrapper<RecommendedItemsResponseType>,
        ): boolean {
          return (
            !('__resolveValueError__' in loadingStateWrapper) &&
            !loadingStateWrapper.isLoading &&
            loadingStateWrapper.data !== undefined
          );
        }.toString(),
        transform: function (
          loadingStateWrapper: LoadingStateWrapper<RecommendedItemsResponseType>,
        ): RecommendedItemsResponseType {
          if (loadingStateWrapper.data === undefined) {
            throw new Error('Loading state wrapper should have data by now.');
          }
          return loadingStateWrapper.data;
        }.toString(),
      },
    },
  });

  return item;
}
